import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Card, ConfigProvider, DatePicker, Popconfirm, Select } from 'antd';
import sk_SK from 'antd/lib/locale/sk_SK';
import moment from 'moment';
import 'moment/locale/sk';
import { useEffect, useState } from 'react';
import { CardContent, Container } from 'semantic-ui-react';
import { Box } from '../../../components/Box';
import { Input } from '../../../components/Input';
import { DATE_TIME_FORMAT } from '../../../constants';
import { Codes, CodesText, MenaCode, ObchodnyRegisterCode, ObecCode, PravnaFormaCode, StatCode, TypInyIdentifikatorCode, TypVkladuCode } from '../pages/Interfaces';
import Navigation from './Navigation';
import UserRegistrationForm from '../../frontoffice/components/UserRegistrationForm';

type currentFileType = {
  name: string,
  content: any
};

const SettingsTemplate = ({
  settings,
  isLoading,
  lambdaUsage,
  saveSettings,
  saveCodes
}: {
  settings: any;
  isLoading: boolean;
  lambdaUsage: any
  saveSettings: (settings: any) => void;
  saveCodes: (codeType: Codes, codes: any) => void
}) => {

  const [dateOfMaintenance, setDateOfMaintenance] = useState(0)
  const [maintenance, setMaintenance] = useState(false)
  const [codeListCurrent, setCodeListCurrent] = useState(Codes.Stat);
  const [currentFile, setCurrentFile] = useState<currentFileType>({
    name: '',
    content: undefined
  })
  const [lambdaLimit, setLambdaLimit] = useState<any>()
  const [lambdaWarning, setLambdaWarning] = useState<any>()

  //const [file2Import, setFile2Import] = useState(new File);

  useEffect(() => {
    if (settings) {
      setDateOfMaintenance(settings.settings['maintenance-date'])
      setMaintenance(settings.settings.maintenance)
      setLambdaLimit(settings.settings.lambdaLimit)
      setLambdaWarning(settings.settings.lambdaWarning)
    }
  }, [settings])

  const save = () => {
    let settings = {
      "maintenance-date": dateOfMaintenance,
      maintenance: maintenance,
      lambdaLimit: lambdaLimit,
      lambdaWarning: lambdaWarning,
    }
    saveSettings(settings)
  }


  const handleFileChange = async (event: any) => {
    setCodeListCurrent(event.target.value);
    for (let oneFile of event.target.files) {
      let reader = new FileReader()
      reader.onload = async (loadEvent: any) => {
        await setCurrentFile({
          name: oneFile.name,
          content: reader.result
        });
      }
      reader.readAsDataURL(oneFile)
    }
  }

  // const processOneFile = (oneFile: any, reader: FileReader, saveCodes: (codeType: Codes, codes: any) => void, code: Codes) => {
  const importCode = () => {

    if (currentFile && currentFile.content && (typeof currentFile.content === 'string' || currentFile.content instanceof String)) {
      const encodedString = currentFile.content.replace(/.*,/, '');

      let base64Decode = Buffer.from(encodedString, "base64").toString();

      let regexp;
      let matches;

      switch (codeListCurrent) {
        case Codes.Stat:
        case Codes.PravnaForma:
        case Codes.TypVkladu:
          regexp = /"([\d]*)",\s"([\w\s\\\\]*)"/gm;
          matches = base64Decode.matchAll(regexp);
          break;

        case Codes.TypInyIdentifikator:
        case Codes.Mena:
          regexp = /"([\d]*)","([\w\sáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)","([\w\sáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)"/g;
          matches = base64Decode.matchAll(regexp);
          break;

        case Codes.Obec:
          regexp = /"([\d]*)","([\s-\(\)A-Za-záäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)"/gm;
          matches = base64Decode.matchAll(regexp);
          break;

        case Codes.ObchodnyRegister:
          regexp = /"([\w\sáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)","([\w\sáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)",([\d]*),"([\w\sáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)","([\w\sáäčďéíľĺňóôŕšťúýž]*)",([\d]*),"([\w\sáäčďéíľĺňóôŕšťúýžÁÄČĎÉÍĽĹŇÓÔŔŠŤÚÝŽ]*)"/g;
          matches = base64Decode.matchAll(regexp);
          break;

        default:
          console.log("Unknown code, implementation error.");
          break;
      }

      if (matches) {
        const parsedCodes = prepareStoreCodes(matches, saveCodes, codeListCurrent);
        saveCodes(codeListCurrent, parsedCodes);
      }

    }
  }

  function prepareStoreCodes(matches: IterableIterator<RegExpMatchArray>, saveCodes: (codeType: Codes, codes: any) => void, code: Codes) {
    let matchIter = matches.next();

    let parsedCodes: any[] = [];

    while (!matchIter.done) {
      let newParsedCode: any;

      switch (code) {
        // 2 fields to import
        case Codes.Stat:
          let statCode: StatCode = {
            codeId: parseInt(matchIter.value[1]),
            value: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body
          };
          newParsedCode = statCode;
          break;

        case Codes.PravnaForma:
          let pravnaFormaCode: PravnaFormaCode = {
            codeId: parseInt(matchIter.value[1]),
            value: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body
          };
          newParsedCode = pravnaFormaCode;
          break;

        case Codes.TypVkladu:
          let typVkladuCode: TypVkladuCode = {
            codeId: parseInt(matchIter.value[1]),
            value: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body
          };
          newParsedCode = typVkladuCode;
          break;

        // 3 fields to import
        case Codes.TypInyIdentifikator:
          let typInyIdentifikatorCode: TypInyIdentifikatorCode = {
            codeId: parseInt(matchIter.value[1]),
            value: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body,
            znacka: JSON.parse('{"body" : "' + matchIter.value[3] + '" }').body
          };
          newParsedCode = typInyIdentifikatorCode;
          break;
        case Codes.Mena:
          let menaCode: MenaCode = {
            codeId: parseInt(matchIter.value[1]),
            value: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body,
            znacka: JSON.parse('{"body" : "' + matchIter.value[3] + '" }').body
          };
          newParsedCode = menaCode;
          break;

        // other fields to import
        case Codes.Obec:
          let obecCode: ObecCode = {
            codeId: parseInt(matchIter.value[1]),
            value: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body,
            statId: 0,
            obce: []
          };
          newParsedCode = obecCode;
          break;

        case Codes.ObchodnyRegister:
          let obchodnyRegisterCode: ObchodnyRegisterCode = {
            okresnySud: JSON.parse('{"body" : "' + matchIter.value[1] + '" }').body,
            ulica: JSON.parse('{"body" : "' + matchIter.value[2] + '" }').body,
            cislo: JSON.parse('{"body" : "' + matchIter.value[3] + '" }').body,
            obec: JSON.parse('{"body" : "' + matchIter.value[4] + '" }').body,
            psc: JSON.parse('{"body" : "' + matchIter.value[5] + '" }').body,
            codeId: parseInt(matchIter.value[6]),
            kod: JSON.parse('{"body" : "' + matchIter.value[7] + '" }').body
          };
          newParsedCode = obchodnyRegisterCode;
          break;

        default:
          console.log("Unknown code, implementation error.")
          newParsedCode = undefined;
      }

      // TODO return error string, so user can know there is error
      if (newParsedCode) {
        parsedCodes.push(newParsedCode);
      }
      matchIter = matches.next();

    }

    return parsedCodes;

  }

  return (
    <div>
      <div>
        <Navigation />
        <Card style={{ background: '#f0f0f0', padding: "4rem 15% 0" }}>
        <h3
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              fontSize: '1.375rem'
            }}>
            Nastavenia

          </h3>
        </Card>
        <Container style={{ padding: '2rem' }}>
          <Card className='backofficeSettingsCard'
            title={'Údržba'}
            extra={
              <>
                <Popconfirm
                  title="Chcete uložiť zmeny?"
                  onConfirm={save}
                  okText="Áno"
                  cancelText="Nie">
                  <Button className='addButton' type="primary">
                    Uložiť
                  </Button>
                </Popconfirm>
              </>
            }>
            <Box display="flex">
              <Box width="80%" margin="0 auto">
                <div className="flexGrid" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  <ConfigProvider locale={sk_SK}>
                    <DatePicker
                      showTime={{}}
                      format={DATE_TIME_FORMAT}
                      style={{ height: 42, width: '40%' }}
                      value={dateOfMaintenance ? moment(dateOfMaintenance!) : undefined}
                      placeholder="Dátum nadchádzajúcej údržby"
                      onChange={(date) => { setDateOfMaintenance(moment(date).valueOf()) }}
                    />
                  </ConfigProvider>
                  <Input
                    type='checkbox'
                    label="Prebieha údržba?"
                    style={{ height: 35, width: 30 }}
                    name="maintenance"
                    checked={maintenance}
                    onChange={(e) => { setMaintenance(e.target.checked) }}
                  />
                </div>

              </Box>
            </Box>
          </Card>
          <Card className='backofficeSettingsCard'
            title={'Lambda'}>
            <Box display="flex">
              <Box width="80%" margin="0 auto">
                <div className="flexGrid" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  <Input
                    label="Limit lambdy"
                    name="lambdaLimit"
                    value={lambdaLimit}
                    onChange={(e) => { setLambdaLimit(e.target.value) }}
                  />
                </div>
                <div className="flexGrid" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  <Input
                    label="Varovanie lambdy"
                    name="lambdaWarning"
                    value={lambdaWarning}
                    onChange={(e) => { setLambdaWarning(e.target.value) }}
                  />
                </div>
                <div className="flexGrid" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  Dnešné zaťaženie lambdy: {lambdaUsage}
                </div>
              </Box>
            </Box>
          </Card>
          <Card className='backofficeSettingsCard'
            title={'Import FUZS číselníkov'}
            extra={
              <>
                <Popconfirm
                  title="Chcete importovať číselník?"
                  onConfirm={importCode}
                  okText="Áno"
                  cancelText="Nie" >
                  <Button className='addButton' type="primary">
                    Importovať
                  </Button>
                </Popconfirm>
              </>
            }>
            <Box display="flex">
              <Box width="80%" margin="0 auto" >
                <div className="flexGrid" style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
                  <ConfigProvider locale={sk_SK}>
                    <Select
                      className='fuzsSearch'
                      showSearch
                      placeholder="Vyberte číselník"
                      optionFilterProp="children"
                      onChange={(e) => { setCodeListCurrent(Codes[e as Codes]); }}
                      // filterOption={(input, option) =>
                      //   (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      // }
                      options={
                        (Object.keys(Codes)).map((key) => {
                          return {
                            value: key,
                            label: Codes[key as Codes]
                          };
                        })
                      }
                      value={codeListCurrent ? (CodesText[codeListCurrent as Codes]) : "Vyberte číselník"}
                    />

                    <span>{currentFile.name}</span>
                    <span className="orderItemUploadIcons">
                      <input
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        id={'admin_code_upload_picker'}
                        type="file" />
                      <label
                        htmlFor={'admin_code_upload_picker'}>
                        Importovať číselník
                        <PlusCircleOutlined style={{ marginLeft: 15 }} />
                      </label>
                    </span>
                  </ConfigProvider>
                </div>
              </Box>
            </Box>
          </Card>
        </Container>
      </div>

    </div>
  );
};

export default SettingsTemplate;
